import { render, staticRenderFns } from "./group.vue?vue&type=template&id=0a3942a5&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=0a3942a5&prod&scoped=true&lang=less"
import style1 from "./group.vue?vue&type=style&index=1&id=0a3942a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3942a5",
  null
  
)

export default component.exports